module.exports = __webpack_public_path__ + "static/img/wanasaImage.6b3be0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wanasaImage.png
// module id = 523
// module chunks = 1